<div class="mt-16 grid grid-cols-12 flex-col text-tertiary-900">
    <section class="col-start-3 col-span-8 text-2xl">
        <span
            >I have completed the application and attest to its accuracy. EWA is
            requested to submit the application to the FCC for processing. EWA
            and any associated FCC fees apply.</span
        >
    </section>
    <section class="col-start-3 col-span-8 w-full">
        <app-submit-to-ewa-form-submission
            (submitForm)="handoverToEwaSubmission()"
            [disableSubmission]="!enableSubmission()"
        >
        </app-submit-to-ewa-form-submission>
    </section>
</div>
